import React from 'react'

export const Input = ({
  label,
  placeholder,
  value,
  onChange,
  disabled,
  helperText,
  className = '',
}) => {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <label className="block text-sm font-medium text-gray-700 drop-shadow-sm">{label}</label>
      <div className="group relative">
        {/* Frosty borders */}
        <div className="absolute left-0 right-0 top-0 h-[1px] rounded-t-lg bg-gradient-to-r from-transparent via-white/60 to-transparent opacity-70"></div>
        <div className="absolute bottom-0 left-0 right-0 h-[1px] rounded-b-lg bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-50"></div>
        <div className="absolute bottom-[10%] left-0 top-[10%] w-[1px] bg-gradient-to-b from-transparent via-white/40 to-transparent opacity-50"></div>
        <div className="absolute bottom-[10%] right-0 top-[10%] w-[1px] bg-gradient-to-b from-transparent via-white/40 to-transparent opacity-50"></div>

        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full rounded-lg border border-white/30 bg-white/40 p-3 shadow-sm backdrop-blur-md transition-all duration-300 hover:shadow-md focus:border-transparent focus:bg-white/50 focus:shadow-[0_0_0_2px_rgba(255,255,255,0.7),0_0_0_4px_theme(colors.accent-400/30),0_0_15px_theme(colors.accent-400/20)] focus:outline-none ${disabled ? 'cursor-not-allowed bg-gray-100/80' : ''} relative z-10`}
        />

        {/* Light refraction effect */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-lg">
          <div className="bg-gradient-radial absolute -right-[150%] -top-[150%] h-[300%] w-[300%] rotate-12 from-white/30 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-30"></div>
        </div>
      </div>
      {helperText && <p className="mt-1 text-xs text-gray-500 drop-shadow-sm">{helperText}</p>}
    </div>
  )
}
